import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BankServices from "../../../Services/QRCodeServices/BankServices/BankServices";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import CustomerServices from "../../../Services/QRCodeServices/CustomerServices/CustomerServices";
import CustomerForm from "../../Customer/Components/CustomerForm";

const paymentOptions = [
  { label: "Bank", value: 1 },
  { label: "Cash", value: 2 },
  { label: "Card", value: 3 },
  { label: "Online", value: 4 },
  { label: "Credit", value: 5 },
];
const creditOptions = [
  { label: "Cash", value: 2 },
  { label: "Card", value: 3 },
  { label: "Online", value: 4 },
  { label: "Bank", value: 1 },
];

// Validation schema using Yup
const validationSchema = Yup.object({
  type: Yup.number().required("Payment type is required"),
  customerId: Yup.number().when("type", {
    is: "5",
    then: (schema) =>
      schema.required("Customer is required for credit payment"),
    otherwise: (schema) => schema.nullable(),
  }),
  name: Yup.string().when("type", {
    is: (val) => val !== "5",
    then: (schema) => schema.required("Name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  phoneNumber: Yup.string().when("type", {
    is: (val) => val !== "5",
    then: (schema) =>
      schema
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  address: Yup.string().when("type", {
    is: (val) => val !== "5",
    then: (schema) => schema.required("Address is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  remarks: Yup.string(),
  BankId: Yup.number()
    .typeError("Please select a bank")
    .when(["type", "paymentMethod", "paidAmount"], {
      is: (type, paymentMethod, paidAmount) =>
        type === "1" || (type === "5" && paymentMethod === 1 && paidAmount > 0),
      then: (schema) => schema.required("Bank selection is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  paidAmount: Yup.number()
    .typeError("Please enter a valid amount")
    .min(0, "Paid amount cannot be negative")
    .when("type", {
      is: "5",
      then: (schema) => schema.required("Paid amount is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  paymentMethod: Yup.number().when(["paidAmount", "type"], {
    is: (paidAmount, type) => type === "5" && paidAmount > 0,
    then: (schema) => schema.required("Payment method is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const PaymentModal = ({
  isOpen,
  toggle,
  onSubmit,
  loading,
  orderId,
  netAmount,
  fetchTable,
  storeDiscount,
  setStoreDiscount,
  selectedPaymentType,
  setSelectedPaymentType,
}) => {
  console.log("🚀 ~ PaymentModal ~ orderId:", orderId);
  console.log("🚀 ~ PaymentModal ~ selectedPaymentType:", selectedPaymentType);

  const handleDiscountChange = (e) => {
    const value = e.target.value ? Number(e.target.value) : 0;
    setStoreDiscount(value); // update local state
    formik.setFieldValue("addDiscount", value); // update formik field
  };
  const [bankList, setBankList] = useState([]);
  const [showPaymentOptionCredit, setShowPaymentOptionCredit] = useState(false);

  const [customerData, setCustomerData] = useState([]);

  const [isCustomerOpen, setIsCustomerOpen] = useState(false);
  const toggleCustomer = () => {
    setIsCustomerOpen(!isCustomerOpen);
  };
  const fetchCustomer = async () => {
    try {
      const response = await CustomerServices.getList();
      setCustomerData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCustomer();
  }, []);

  const customerOptions = customerData?.map((item) => ({
    value: item?.id,
    label: `${item?.firstName || ""} ${item?.lastName || ""}`.trim(),
  }));
  useEffect(() => {
    // When paymentOptions are loaded, set default selected payment type
    if (paymentOptions?.length > 0) {
      const defaultOption = paymentOptions.find((opt) => opt.value == 2); // default type = 2 (Cash)
      setSelectedPaymentType(defaultOption);
    }
  }, [paymentOptions]);
  const formik = useFormik({
    initialValues: {
      customerId: null,
      phoneNumber: "",
      address: "",
      name: "",
      type: 2,
      remarks: "",
      printBill: false,
      BankId: "",
      paidAmount: 0,
      paymentMethod: 0,
      menuOrderId: orderId,
      totalBillAmount: netAmount,
      addDiscount: 0,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (orderId && formik.values.type == "5") {
        formik.values.menuOrderId = orderId;
      }

      if (netAmount && formik.values.type == "5") {
        formik.values.totalBillAmount = netAmount;
      }

      console.log(values);
      onSubmit(values);
      fetchTable();
      resetForm();
      toggle();
    },
  });
  console.log("🚀 ~ PaymentModal ~ formik:", formik);

  const resetModal = () => {
    formik.resetForm();
    toggle();
  };
  const handlePaymentTypeChange = (e) => {
    const { value } = e.target;
    console.log("🚀 ~ handlePaymentTypeChange ~ value:", value);

    // Update Formik field
    formik.handleChange(e);

    // Find the full selected payment object
    const selectedOption = paymentOptions.find(
      (option) => option.value == value
    );
    console.log(
      "🚀 ~ handlePaymentTypeChange ~ selectedOption:",
      selectedOption
    );

    // Save entire payment object in state
    setSelectedPaymentType(selectedOption);
  };
  const fetchBanks = async () => {
    try {
      const res = await BankServices.getList();
      const transformedArray = res?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setBankList(transformedArray);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (
      formik.values.type === "1" ||
      (formik.values.paidAmount > 0 && formik.values.paymentMethod == 1)
    ) {
      fetchBanks();
    } else {
      setBankList([]);
    }
  }, [
    formik.values.type,
    formik.values.paidAmount,
    formik.values.paymentMethod,
  ]);

  useEffect(() => {
    if (formik.values.paidAmount > 0) {
      setShowPaymentOptionCredit(true);
    } else {
      setShowPaymentOptionCredit(false);
    }
  }, [formik.values.paidAmount]);

  // Handle customer selection and auto-fill fields
  const handleCustomerChange = (e) => {
    const customerId = e.target.value ? parseInt(e.target.value, 10) : null;
    formik.setFieldValue("customerId", customerId);

    if (customerId && formik.values.type == "5") {
      const selectedCustomer = customerData.find(
        (customer) => customer.id === customerId
      );
      if (selectedCustomer) {
        formik.setFieldValue(
          "name",
          `${selectedCustomer.firstName || ""} ${
            selectedCustomer.lastName || ""
          }`.trim()
        );
        formik.setFieldValue("phoneNumber", selectedCustomer.phoneNo || "");
        formik.setFieldValue("address", selectedCustomer.address || "");
      }
    } else {
      // Clear fields if no customer is selected or type is not credit
      formik.setFieldValue("name", "");
      formik.setFieldValue("phoneNumber", "");
      formik.setFieldValue("address", "");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={resetModal} size="md">
      <ModalHeader toggle={toggle}>Payment Details</ModalHeader>
      <form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row className="mb-3">
            <Col xs={bankList.length > 0 && 6} className="mb-2">
              <label className="form-label">Payment Type</label>
              <select
                className={`form-select ${
                  formik.touched.type && formik.errors.type ? "is-invalid" : ""
                }`}
                name="type"
                value={formik.values.type}
                onChange={handlePaymentTypeChange}
                onBlur={formik.handleBlur}
              >
                {paymentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {formik.touched.type && formik.errors.type && (
                <div className="invalid-feedback">{formik.errors.type}</div>
              )}
            </Col>

            {formik.values.type == 5 && (
              <>
                <Col xs={6} className="mb-2">
                  <div className="d-flex align-items-center gap-2 justify-content-between align-content-center">
                    <div className="w-100">
                      <label className="form-label">Customer</label>
                      <select
                        className={`form-select w-100 ${
                          formik.touched.customerId && formik.errors.customerId
                            ? "is-invalid"
                            : ""
                        }`}
                        name="customerId"
                        value={formik.values.customerId ?? ""}
                        onChange={handleCustomerChange} // 👈 Use custom handler
                        onBlur={formik.handleBlur}
                      >
                        <option value="">Select Customer</option>
                        {customerOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {formik.touched.customerId &&
                        formik.errors.customerId && (
                          <div className="invalid-feedback">
                            {formik.errors.customerId}
                          </div>
                        )}
                    </div>
                    <div className="pt-4">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={toggleCustomer}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </Col>
              </>
            )}

            {((bankList.length > 0 && formik.values.type === "1") ||
              (formik.values.type === "5" &&
                formik.values.paymentMethod == 1 &&
                formik.values.paidAmount > 0 &&
                bankList.length > 0)) && (
              <Col md={6} className="">
                <label htmlFor="BankId">Select bank</label>
                <Select
                  id="BankId"
                  name="BankId"
                  options={bankList}
                  onChange={(option) =>
                    formik.setFieldValue("BankId", option ? option.value : "")
                  }
                  onBlur={() => formik.setFieldTouched("BankId", true)}
                  value={bankList.find(
                    (option) => option.value === formik.values.BankId
                  )}
                  placeholder="Select the Bank"
                  isClearable
                  className={
                    formik.touched.BankId && formik.errors.BankId
                      ? "is-invalid"
                      : ""
                  }
                />
                {formik.touched.BankId && formik.errors.BankId && (
                  <div className="invalid-feedback">{formik.errors.BankId}</div>
                )}
              </Col>
            )}
          </Row>

          {formik.values.type == 5 ? (
            // Auto-filled fields for Credit (non-editable)
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formik.values.name}
                    readOnly // Make field read-only
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phoneNumber"
                    value={formik.values.phoneNumber}
                    readOnly // Make field read-only
                  />
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formik.values.address}
                    readOnly // Make field read-only
                  />
                </div>
              </Col>
              <Col md={6} className="justify-content-end mb-2">
                <label htmlFor="paidAmount">Paid Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="paidAmount"
                  value={formik.values.paidAmount}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.paidAmount && formik.errors.paidAmount && (
                  <div className="invalid-feedback">
                    {formik.errors.paidAmount}
                  </div>
                )}
              </Col>
              {showPaymentOptionCredit && (
                <Col md={6} className="">
                  <label htmlFor="paymentMethod">
                    Select Credit Payment Method
                  </label>
                  <Select
                    id="paymentMethod"
                    name="paymentMethod"
                    options={creditOptions}
                    onChange={(option) =>
                      formik.setFieldValue(
                        "paymentMethod",
                        option ? option.value : ""
                      )
                    }
                    onBlur={() => formik.setFieldTouched("paymentMethod", true)}
                    value={bankList.find(
                      (option) => option.value === formik.values.paymentMethod
                    )}
                    placeholder="Select Payment Method"
                    isClearable
                    className={
                      formik.touched.paymentMethod &&
                      formik.errors.paymentMethod
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {formik.touched.paymentMethod &&
                    formik.errors.paymentMethod && (
                      <div className="invalid-feedback">
                        {formik.errors.paymentMethod}
                      </div>
                    )}
                </Col>
              )}
            </Row>
          ) : (
            // Editable fields for non-Credit types
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className={`form-control ${
                      formik.touched.name && formik.errors.name
                        ? "is-invalid"
                        : ""
                    }`}
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className="invalid-feedback">{formik.errors.name}</div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    className={`form-control ${
                      formik.touched.phoneNumber && formik.errors.phoneNumber
                        ? "is-invalid"
                        : ""
                    }`}
                    name="phoneNumber"
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                    <div className="invalid-feedback">
                      {formik.errors.phoneNumber}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </Col>
            </Row>
          )}

          <div className="mb-3">
            <label className="form-label">Discount Percent</label>
            <input
              type="number"
              className={`form-control ${
                formik.touched.addDiscount && formik.errors.addDiscount
                  ? "is-invalid"
                  : ""
              }`}
              name="addDiscount"
              value={formik.values.addDiscount}
              onChange={handleDiscountChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.addDiscount && formik.errors.addDiscount && (
              <div className="invalid-feedback">
                {formik.errors.addDiscount}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows="2"
            />
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="printBill"
              name="printBill"
              checked={formik.values.printBill}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <label className="form-check-label" htmlFor="printBill">
              Print Bill
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={resetModal}>
            Cancel
          </Button>
          <Button color="success" type="submit" disabled={loading}>
            {loading ? "Processing..." : "Confirm Payment"}
          </Button>
        </ModalFooter>
      </form>

      <CustomerForm
        modal={isCustomerOpen}
        toggleModal={toggleCustomer}
        fetchCustomers={fetchCustomer}
      />
    </Modal>
  );
};

export default PaymentModal;
